<div class="login-area">
  <div class="login-container element-column">
    <img class="logo" alt="logo" src="/assets/img/peace_logo_yoko.png" />

    <div class="login-content">
      <div class="login-detail">
        <label>
          認証処理に失敗しました。<br>
          再度時間を置いてログインしていただくか、<br>
          システム管理者に連絡してください。
        </label>
      </div>
    </div>
  </div>
</div>
